import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {
  DarkButton,
  Icon,
  ActivityIndicator,
  DarkText,
  DarkPopup,
  TooltipPopup
} from '@lyearn-team/frontend-components';
import c from 'classnames';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withTheme } from 'emotion-theming';
import windowResize from '../../../helper/WindowResize';
import AnimateSliderBottom from '../../../learner/views/DarkHomePage/model-views/AnimateSliderBottom';
import Certificate from './Certificate';
import styles from './darkStyles';

const TEMPLATE_BASE_HEIGHT = 750;
const TEMPLATE_BASE_WIDTH = 1030;

const linkedInPreFilledURL = ({ activityTitle, completionDateUnformatted, number, url }) => {
  const certificateUrl = `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${encodeURI(
    activityTitle
  )}&issueYear=${new Date(completionDateUnformatted).getFullYear()}&issueMonth=${new Date(
    completionDateUnformatted
  ).getMonth()}&certUrl=${encodeURIComponent(url)}&certId=${number}`;

  return certificateUrl;
};

@withTheme
class DarkCertificatePreview extends Component {
  constructor(props) {
    super(props);
    if (!this.certificateNode) {
      this.certificateNode = document.createElement('div');
      this.certificateNode.id = 'certificate-node';
      document.body.appendChild(this.certificateNode);
    }
    const windowWidth = props.windowWidth;
    const windowHeight = props.windowHeight;
    const isMobile = windowWidth < 767;
    const availableWidth = windowWidth * (isMobile ? 0.9 : 1);
    const availableHeight = windowHeight - 300;
    const templateWidth = Math.max(availableWidth, TEMPLATE_BASE_WIDTH);
    const templateHeight = Math.max(availableHeight, TEMPLATE_BASE_HEIGHT);
    this.state = {
      active: 'none',
      copied: false,
      downloadOpened: false,
      ratio: isMobile ? availableWidth / templateWidth : availableHeight / templateHeight,
      isMobile,
      showShareOptions: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.windowWidth !== this.props.windowWidth) {
      const windowHeight = this.props.windowHeight;
      const windowWidth = this.props.windowWidth;
      const isMobile = windowWidth < 767;
      const availableWidth = windowWidth * (isMobile ? 0.9 : 1);
      const availableHeight = windowHeight - 270;
      const templateWidth = Math.max(availableWidth, TEMPLATE_BASE_WIDTH);
      const templateHeight = Math.max(availableHeight, TEMPLATE_BASE_HEIGHT);
      this.setState({
        ratio: isMobile ? availableWidth / templateWidth : availableHeight / templateHeight,
        isMobile
      });
    }
  }

  showHideMobileSort = () => {
    this.setState({ showShareOptions: !this.state.showShareOptions });
  };

  renderCertificateActions = () => {
    const { theme } = this.props;
    const { ratio, isMobile, showShareOptions } = this.state;
    if (!this.props.renderActions) {
      return null;
    }
    const { certificateSettings } = this.props;
    const tabs = [
      {
        text: 'Add to LinkedIn',
        onClick: this.changeActiveTab('linkedin'),
        name: 'linkedin',
        icon: true
      },
      {
        text: 'Share Certificate',
        onClick: this.changeActiveTab('forward'),
        name: 'upload',
        icon: true
      },
      {
        text: 'Download as PDF',
        onClick: this.changeActiveTab('download'),
        name: 'download',
        icon: false
      }
    ];
    if (certificateSettings && certificateSettings.dontPublishOnLinkedIn) {
      tabs.splice(0, 1);
    }
    const white = theme.color.dark.white;
    if (isMobile) {
      return (
        <React.Fragment>
          {!showShareOptions ? (
            <DarkButton.SecondaryButton
              className={styles.shareButton}
              onClick={this.showHideMobileSort}
              size="medium"
              uppercase={true}
            >
              <Icon type="share" style={{ marginRight: '8px', width: 16, fill: white }} />
              Share Certificate
            </DarkButton.SecondaryButton>
          ) : (
            <AnimateSliderBottom
              closeSlider={this.showHideMobileSort}
              className={styles.animateSlider}
            >
              <div className="optionsWrapper">
                <DarkText
                  className="header"
                  as="div"
                  letterSpacing={0.5}
                  fontSize={12}
                  uppercase={true}
                  color="white"
                >
                  Share Certificate
                </DarkText>
                {tabs.map(tab => (
                  <DarkText
                    className="option"
                    as="div"
                    letterSpacing="normal"
                    fontSize={14}
                    onClick={tab.onClick}
                  >
                    <Icon
                      type={tab.name}
                      style={{
                        width: 16,
                        marginRight: '8px',
                        fill: white
                      }}
                    />
                    {tab.text}
                  </DarkText>
                ))}
              </div>
            </AnimateSliderBottom>
          )}
        </React.Fragment>
      );
    }
    return (
      <div className={styles.tabWrapperContainer(Math.min(0.7, ratio) * TEMPLATE_BASE_WIDTH)}>
        <div className="tabWrapper">
          {tabs.map(tab => {
            const iconSize = tab.name === 'linkedin' ? '23px' : '16px';
            return (
              <div className={styles.tab()}>
                <DarkButton.TextButton onClick={tab.onClick}>
                  <div className="wrapper">
                    <Icon
                      type={tab.name}
                      style={{
                        width: iconSize,
                        height: iconSize,
                        marginRight: '7px',
                        marginTop: '2px',
                        fill: white
                      }}
                    />
                    <DarkText
                      className={styles.buttonText()}
                      color="white"
                      fontSize={12}
                      as="div"
                      letterSpacing={0.5}
                    >
                      {tab.text}
                    </DarkText>
                  </div>
                </DarkButton.TextButton>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  redirectToLinkedin = certificate => () => {
    const url = linkedInPreFilledURL(certificate);
    window.open(url, '_blank');
  };

  redirectToCertificate = url => {
    window.open(url, '_blank');
  };

  renderOpenTab = () => {
    if (!this.props.renderActions) {
      return null;
    }
    const { active, downloadOpened } = this.state;
    if (active === 'linkedin' || active === 'forward') {
      const { certificateDetails } = this.props;
      const link = certificateDetails.url;
      return (
        <DarkPopup
          showPopup={true}
          onOverlayClick={this.changeActiveTab('none')}
          style={{
            zIndex: '1050'
          }}
          popupClassName={c('infoPopup', active === 'linkedin' && 'fullheight')}
        >
          {active === 'linkedin'
            ? this.renderLinkedinTab(certificateDetails)
            : this.renderShareTab(link)}
        </DarkPopup>
      );
    }

    if (active === 'download' && !downloadOpened) {
      const iframe = document.getElementById('certificateIframe');
      const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      const head = innerDoc.head || document.getElementsByTagName('head')[0];

      if (!head.hasChildNodes('style')) {
        const previewStyle = document.createElement('style');
        previewStyle.appendChild(
          document.createTextNode(`
          @font-face {
            font-family: 'ProximaNova';
            src: local('ProximaNova Regular'), local('ProximaNova-Regular'), url(https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/fonts/proximanova/proximanova-regular.otf) format('truetype');
          }
          @page { size: 279mm 221mm; margin: 5mm; }
          html,body{
            width: 297mm;
            height: 210mm;
            margin: 4mm auto;
          }
          .certificateContainer{
            margin: auto;
          }`)
        );
        head.appendChild(previewStyle);
      }
      document.getElementById('certificateIframe') &&
        document.getElementById('certificateIframe').contentWindow.print();
      this.setState({
        downloadOpened: true
      });
    }
    return null;
  };

  changeActiveTab = activeTab => () => {
    const { active } = this.state;
    let newActive = activeTab;
    if (active === activeTab && activeTab !== 'download') {
      newActive = 'none';
    }
    if (activeTab === 'download') {
      this.setState({
        downloadOpened: false
      });
    }
    this.setState({
      active: newActive,
      copied: false
    });
  };

  renderClose = () => (
    <DarkButton.IconButton onClick={this.changeActiveTab('none')} className="closeButton">
      <Icon type="close" className="icon" />
    </DarkButton.IconButton>
  );

  renderLinkedinTab = certificate => {
    const { isMobile } = this.state;
    const fields = [
      {
        text: 'Certificate Name:',
        key: 'activityTitle',
        showCopy: true
      },
      {
        text: 'Certificate authority:',
        key: 'company',
        showCopy: true
      },
      {
        text: 'License number:',
        key: 'number',
        showCopy: true
      },
      {
        text: 'Issue Date:',
        key: 'from'
      },
      {
        text: 'Expiration Date:',
        key: 'to'
      },
      {
        text: 'Certificate URL:',
        key: 'url',
        showCopy: true
      }
    ];
    return (
      <div className={styles.tabInnerWrapper(isMobile)}>
        {this.renderClose()}
        <DarkText
          className={styles.tabInnerHeader()}
          as="div"
          fontSize={18}
          color="silver"
          letterSpacing="normal"
        >
          Add to LinkedIn
        </DarkText>
        <DarkText
          className={styles.tabInnerInstruction()}
          as="div"
          fontSize={isMobile ? 16 : 14}
          color={isMobile ? 'silver' : 'copper'}
          letterSpacing="normal"
        >
          Add this to your LinkedIn account under the user profile section and let your professional
          network know about this awarded credential.
        </DarkText>
        {fields.map(field => (
          <div className={styles.tabInnerDetails(isMobile)}>
            <DarkText
              className={styles.tabInnerDetailsContent('key', isMobile)}
              fontSize={14}
              color="iron"
              letterSpacing="normal"
            >
              {field.text}
            </DarkText>
            <DarkText
              className={styles.tabInnerDetailsContent('value', isMobile)}
              fontSize={14}
              color="copper"
              letterSpacing="normal"
            >
              {field.text.includes('URL') ? (
                <DarkButton.TextButton
                  className="certificateUrl"
                  onClick={() => this.redirectToCertificate(certificate[field.key])}
                >
                  {certificate[field.key]}
                </DarkButton.TextButton>
              ) : (
                certificate[field.key]
              )}
              {field.showCopy ? (
                <CopyToClipboard text={certificate[field.key]}>
                  <div className="copyIconContainer">
                    {!isMobile ? (
                      <TooltipPopup
                        title={
                          <DarkText className="text" as="div" fontSize={12} letterSpacing="normal">
                            Copy to Clipboard
                          </DarkText>
                        }
                        placement={field.text.includes('URL') ? 'left' : 'right'}
                        trigger="hover"
                        showCross={false}
                        hideArrow={true}
                        className="copyToClipboard"
                        leftOffset={field.text.includes('URL') ? -10 : 10}
                      >
                        <Icon type="duplicate" className="copyIcon" />
                      </TooltipPopup>
                    ) : (
                      <Icon type="duplicate" className="copyIcon" />
                    )}
                  </div>
                </CopyToClipboard>
              ) : null}
            </DarkText>
          </div>
        ))}

        <DarkButton.SecondaryButton
          className="goToLinkedIn"
          onClick={this.redirectToLinkedin(certificate)}
          size={isMobile ? 'medium' : 'small'}
          uppercase={true}
        >
          {isMobile ? '' : 'Go to Linkedin'}
          <Icon type="globe" className="icon" />
          {isMobile ? 'Go to Linkedin' : ''}
        </DarkButton.SecondaryButton>
      </div>
    );
  };

  renderShareTab = link => {
    const { copied, isMobile } = this.state;
    return (
      <div className={styles.tabInnerWrapper(isMobile)}>
        {this.renderClose()}
        <DarkText
          className={styles.tabInnerHeader(isMobile)}
          as="div"
          fontSize={isMobile ? 32 : 18}
          color="silver"
          letterSpacing="normal"
        >
          Share Certificate
        </DarkText>
        <DarkText
          className={styles.tabInnerInstruction()}
          as="div"
          fontSize={14}
          color="copper"
          letterSpacing="normal"
        >
          Copy the link below to share your credential with your professional network.
        </DarkText>
        <div style={{ display: 'flex' }}>
          <div className={styles.darkLinkStyle(isMobile)}>
            <p className="url">{link}</p>
            <div className={styles.copyButtonWrapper()}>
              <div className={styles.copyButtonSeperator()} />
              <CopyToClipboard text={link} onCopy={() => this.setState({ copied: true })}>
                <DarkButton.TextButton onClick={() => {}} className={styles.copyButton()}>
                  {copied ? 'Copied' : 'Copy'}
                </DarkButton.TextButton>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderCertificatePreview = () => {
    const { loading, theme, ...restProps } = this.props;
    const { isMobile, ratio } = this.state;

    if (loading) {
      return (
        <div className={styles.previewContainer(loading, isMobile)}>
          <ActivityIndicator />
        </div>
      );
    }

    const style = {
      transform: isMobile ? `scale(${ratio})` : `scale(${Math.min(0.7, ratio)})`,
      transformOrigin: 'center center',
      backgroundColor: 'rgb(255, 255, 255)',
      position: 'relative'
    };

    const { userDetails, certificateDetails, renderActions } = restProps;
    const userName = userDetails.userName.split(' ')[0];
    const { activityType, activityTitle } = certificateDetails;

    return (
      <div
        className={styles.previewContainer(false, isMobile)}
        onClick={event => event.stopPropagation()}
        role="button"
        tabIndex="0"
      >
        <div className={styles.headerRoot(isMobile)}>
          <DarkButton.IconButton onClick={event => this.props.onLayoutCloseClick(event)}>
            <Icon
              type="arrow-left"
              style={{ width: isMobile ? 20 : 28, fill: theme.color.dark.white }}
            />
          </DarkButton.IconButton>
        </div>
        <div className={styles.certificateInfo(isMobile)}>
          <DarkText
            className="completion"
            fontSize={isMobile ? 12 : 14}
            letterSpacing={2}
            color="copper"
            uppercase={true}
            as="div"
          >
            Certificate of Completion
          </DarkText>
          <DarkText
            className="congratulations"
            fontSize={isMobile ? 24 : 44}
            letterSpacing="normal"
            color="silver"
            as="div"
          >
            {renderActions ? `Congratulations, ${userName}! 🎉` : userDetails.userName}
          </DarkText>
          <DarkText
            className="contentInfo"
            fontSize={isMobile ? 12 : 14}
            letterSpacing="normal"
            color="iron"
            as="div"
          >
            {renderActions
              ? 'You have been awarded a certificate for completing'
              : 'Awarded a certificate for successfully completing'}
            <span className="contentName"> {activityTitle} </span>
            {activityType === 'liveTraining' || activityType === 'ilt' || activityType === 'ILT'
              ? 'live training'
              : activityType}
          </DarkText>
        </div>
        {this.renderOpenTab()}
        <div className={styles.certificateContainer(isMobile, TEMPLATE_BASE_HEIGHT * ratio)}>
          <Certificate {...restProps} showClose={false} style={style} />
        </div>
        {this.renderCertificateActions()}
      </div>
    );
  };

  render() {
    return ReactDOM.createPortal(this.renderCertificatePreview(), this.certificateNode);
  }
}

export default windowResize(DarkCertificatePreview);
